import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { AssetRecoveryCase } from '../../../../types';

type CellParams = ICellRendererParams<AssetRecoveryCase> & {
  summaryCallback: (caseData: AssetRecoveryCase) => void;
};

@Component({
  selector: 'app-cell-asset-recovery-summary-actions',
  imports: [UiModule, MatTooltipModule],
  templateUrl: './cell-asset-recovery-summary-actions.component.html',
})
export class CellAssetRecoverySummaryActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  onSummaryClick() {
    if (!this.params.data) {
      return;
    }

    this.params.summaryCallback(this.params.data);
  }
}
